import ImagePlaceholder from '../common/ImagePlaceholder'; // Assuming path

const ImageGallery = ({ images, docDetails, docFilename, imageDataUriMap, onOpenImageModal }) => {
  return (
    <div className="document-image-gallery">
      <h4>Image text hits ({images.length}) - click on image for info</h4>
      <div className="image-thumbnails-grid">
        {images.map((image, imgIdx) => {
          const alt = `Thumbnail ${imgIdx + 1} from ${docDetails?.real_name || docFilename}${image.page ? ` (Page ${image.page})` : ''}`;
          const originalDocFilenameForImage = docDetails?.original_pdf_filename || docDetails?.filename || docFilename;
          const docLinkForImage = typeof docDetails?.file_link === 'string' && docDetails.file_link !== 'Nan' ? docDetails.file_link : null;
          const docNameForImage = docDetails?.real_name || docFilename;
          const imageStatus = imageDataUriMap[image.image_path];

          const imageMatchedTerms = image.matched_terms || [];

          return (
            <div
              key={image.image_path}
              onClick={() => imageStatus?.uri ? onOpenImageModal(image.image_path, alt, image.caption, image.page, originalDocFilenameForImage, docLinkForImage, docNameForImage) : null}
              className={`document-image-thumbnail-container ${!imageStatus?.uri ? 'no-click' : ''}`}
              title={imageStatus?.uri ? `View Image ${imgIdx + 1}${image.page ? ` (P. ${image.page})` : ''}` : (imageStatus?.error ? 'Error loading image' : 'Image loading or unavailable')}
            >
              {imageStatus?.uri ? (
                <img src={imageStatus.uri} alt={alt} />
              ) : imageStatus?.error ? (
                <div className="image-thumbnail-error" title={imageStatus.error}><i className='bx bx-error-circle'></i></div>
              ) : (
                <ImagePlaceholder />
              )}
              {image.page != null && (<span className="image-page-number">P. {image.page}</span>)}
              {imageMatchedTerms.length > 0 && (
                <div className="image-matched-terms">
                  {imageMatchedTerms.map(([term, freq]) => (
                    <span key={term} className="image-matched-term-badge">{term}: {freq}</span>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ImageGallery;